import { safeJsonStringify } from '@/utils/stringUtil'

export const getDocumentAckMetadataPayload = (event: Event, urlPath: string) => {
    const serializedEvent = safeJsonStringify(event)
    return {
        browserEvent: serializedEvent,
        localTimestamp: new Date().toString(),
        urlPath,
    } as const
}
